import { InjectionKey, Ref } from 'vue';

export const ProvidedAllFieldsExpansion: InjectionKey<{
  isExpanded: Readonly<Ref<boolean>>;
  generation: Readonly<Ref<number>>;
}> = Symbol('ProvidedAllFieldsExpansion');
